module.exports = __webpack_public_path__ + "static/media/logo-escola_contas.99cfbd96.png";